import React from 'react'
import { Box, TextField, Typography } from '@mui/material'

import { BudgetStepProps } from '../types'

const BudgetStep: React.FC<BudgetStepProps> = ({ value, onChange }) => {
  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        What&apos;s your budget rent per month?
      </Typography>

      <TextField
        fullWidth
        placeholder="Your answer"
        value={value}
        onChange={e => onChange(e.target.value)}
        variant="outlined"
        size="medium"
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            '& fieldset': {
              borderColor: '#e0e2ef',
            },
            '&:hover fieldset': {
              borderColor: '#c1c7d0',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#050a22',
              borderWidth: '1px',
            },
          },
          '& .MuiOutlinedInput-input': {
            padding: '12px 14px',
          },
        }}
      />
    </Box>
  )
}

export default BudgetStep
